import { REPORT_PROVIDER_REGISTRY }            from './registry'
import { SalesReportProvider }                 from './providers/SalesReportProvider'
import { ConfirmationReportProvider }          from './providers/ConfirmationReportProvider'
import { ShippingConfirmationReportProvider }  from './providers/ShippingConfirmationReportProvider'
import { CustomerServiceReportProvider }       from './providers/CustomerServiceReportProvider'

REPORT_PROVIDER_REGISTRY.register(SalesReportProvider)
REPORT_PROVIDER_REGISTRY.register(ConfirmationReportProvider)
REPORT_PROVIDER_REGISTRY.register(ShippingConfirmationReportProvider)
REPORT_PROVIDER_REGISTRY.register(CustomerServiceReportProvider)
